import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { ElementBaseQuickSettingRect, IElementBaseQuickSettingRect } from './model/base';
import { ShapeQuickSettingRect } from './model/shape';
import { GroupQuickSettingRect } from './model/group';
import { ChartQuickSettingRect } from './model/chart';
import { TableQuickSettingRect } from './model/table';
import { MultiplyQuickSettingRect } from './model/multiply';

export function getQuickSettingRectByModel(model: IElementBaseModel | IMultiplyModel): IElementBaseQuickSettingRect {
    switch (model.type) {
        case UIModelType.SHAPE:
            return new ShapeQuickSettingRect(model as IShapeModel);
        case UIModelType.GROUP:
            return new GroupQuickSettingRect(model as IGroupModel);
        case UIModelType.TABLE:
            return new TableQuickSettingRect(model as ITableModel);
        case UIModelType.CHART:
            return new ChartQuickSettingRect(model as IChartModel);
        case UIModelType.MULTIPLY:
            return new MultiplyQuickSettingRect(model as IMultiplyModel);
        case UIModelType.IMAGE:
        case UIModelType.CONNECTOR:
        default:
            return new ElementBaseQuickSettingRect(model as IElementBaseModel);
    }
}
